import React from 'react';
import PropTypes from 'prop-types';
import IconButton from '@material-ui/core/IconButton';
import { withStyles } from '@material-ui/core/styles';

import { ElemType, MapClassesToElem } from '../../helpers/styles-helpers';
import removeEdit from '../../assets/svg/remove-edit.svg';
import styles from './remove-edit-button.styles';

function RemoveEditButton({ classes, onClick, mode, disabled }) {
  return (
    <IconButton
      disabled={disabled}
      classes={
        mode
          ? MapClassesToElem(`${mode}-${ElemType.IconButton}`, classes)
          : MapClassesToElem(ElemType.IconButton, classes)
      }
      onClick={onClick}
    >
      <img src={removeEdit} alt="remove" />
    </IconButton>
  );
}

RemoveEditButton.propTypes = {
  classes: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
  mode: PropTypes.oneOf([null, 'big']),
  disabled: PropTypes.bool
};

RemoveEditButton.defaultProps = {
  mode: null,
  disabled: false
};

export default withStyles(styles)(RemoveEditButton);
